import {useState} from "react";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {ExportStatusCMP, ExportTypeCMP} from "@/pages/admin/export/_section/ExportTypeCMP";
import {formatDateFull} from "@/lib/utils/date";
import RenderIf from "@/components/render-if";
import {Alert, Button, Card, message, Popconfirm, Radio} from "antd";
import {Link, useNavigate} from "react-router-dom";
import {Can} from "@/components/can/Can";
import PermList from "@/lib/helper/PermList";
import {FileExcelOutlined} from "@ant-design/icons";
import TableSearch from "@/components/table/tableSearch";
import {exportApiRepository} from "@/api/exportApiRepository";
import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";

export default function AdminExportPage() {


    const [needRefetch, setNeedRefetch] = useState(false)
    const {mutate: cancelExport, isPending} = exportApiRepository.useDeleteExport()
    const {mutate: createExport, isPending: isPendingCreate} = exportApiRepository.useCreateNewExport()


    const handleCancelExport = (id) => {
        cancelExport(
            {id: id},
            {
                onSuccess: (r) => {
                    ApiHandleSuccessMessage(r)
                    setNeedRefetch(true)

                },
                onError: (e) => {
                    ApiHandleErrorMessage(e)
                }
            }
        )
    }


    const columns = [
        {
            title: 'نوع',
            dataIndex: 'type',
            key: 'type',
            render: (text, record) => <div className={''}><ExportTypeCMP text={text}/></div>
        },
        {
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => <div className={''}><ExportStatusCMP text={text}/></div>
        },
        {
            title: 'تاریخ ایجاد',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record) => {
                return <div className={``}><span
                    className={`text-xs text-gray-7`}></span> <span>{formatDateFull(text)}</span></div>;
            }
        },
        {
            title: ' ',
            dataIndex: ' ',
            key: '',
            render: (text, record) => {
                return <div className={``}>
                    <RenderIf condition={record?.url}>
                        <Button size={'small'} type={'primary'}><Link to={record.url} target={'_blank'}>دانلود
                            فایل</Link></Button>
                    </RenderIf>
                    <RenderIf condition={!record?.url && (record?.status !== 'cancelled')}>
                        <Popconfirm title={'لغو درخواست'}
                                    disabled={isPending}
                                    onConfirm={() => {
                                        handleCancelExport(record?.id)
                                    }}
                                    description={'آیا از لغو درخواست اطمینان دارید؟'}>
                            <Button size={'small'} danger loading={isPending}>
                                لغو درخواست
                            </Button>
                        </Popconfirm>
                    </RenderIf>
                </div>;
            }
        }

    ]


    const [exportValue, setExportValue] = useState('')
    const [loadingExport, setLoadingExport] = useState(false)
    const navigate = useNavigate();
    const onChange = e => {
        setExportValue(e.target.value);
    };

    const exportList = [
        {
            key: 'product-delivery-export',
            title: 'خروجی از لیست اقلام قابل تحویل',

        },


    ]


    function handleExport() {

        if (!exportValue) {
            message.error('لطفا نوع خروجی را مشخص کنید')
            setLoadingExport(false);
            return;
        }

        createExport({type: exportValue}, {
            onSuccess: r => {
                ApiHandleSuccessMessage(r)
                setNeedRefetch(true)
            },
            onError: (e) => {
                ApiHandleErrorMessage(e)
            }
        })


    }


    return (<>
        <AdminLayout pageTitle={'دریافت فایل خروجی'} backTo={URLS.admin.setting.dashboard}>
            <Can permission={PermList.EXPORTS_ADD}>
                <Card>
                    <div className={'rounded-lg mb-5'}>
                        <h3 className={'font-bold'}>ثبت درخواست خروجی</h3>
                        <p className={'mb-5'}>در این قسمت می‌توانید درخواست خروجی از اطلاعات موردنظر خود را ثبت کنید. پس
                            از ثبت،
                            درخواست شما بررسی و آماده دانلود خواهد شد.
                        </p>
                        <hr className="mb-5"/>
                        <Radio.Group
                            className={'mb-5'}
                            onChange={onChange}
                            value={exportValue}

                        >
                            <div className="flex flex-wrap gap-2">
                                {exportList.map((item, index) => (
                                    <Radio
                                        key={index + ' ' + item.key + 'export-list'}
                                        className={`border-2 p-2 rounded-lg ${exportValue === item.key ? ' border-blue-400 text-blue-600' : ''}>`}
                                        value={item.key}>
                                        <FileExcelOutlined
                                            className={`icon-users  text-[18px] mx-2 ${exportValue === item.key ? ' border-blue-400 text-blue-600' : ''}`}
                                        />

                                        <span
                                            className={`${exportValue === item.key ? ' border-blue-400 text-blue-600' : ''}`}>
                                                {item.title}
                            </span>

                                    </Radio>
                                ))}

                            </div>

                        </Radio.Group>
                        <Button

                            size={'large'}
                            onClick={handleExport}
                            loading={isPendingCreate}
                            className={'mx-2'} variant={'solid'} color={'primary'}>
                            ثبت درخواست خروجی
                        </Button>

                    </div>

                    <Alert
                        type={'info'}
                        description={
                            '  در این قسمت می‌توانید لیست درخواست‌های خود برای دریافت خروجی از اطلاعات کانون را مشاهده کنید و در صورتی که فرایند دریافت خروجی به اتمام رسیده است فایل اطلاعات را دانلود کنید'}
                    >

                    </Alert>
                </Card>
            </Can>

            <TableSearch
                columns={columns}
                apiFn={exportApiRepository.useGetList}
                needRefetch={needRefetch}
                setNeedRefetch={setNeedRefetch}

            />
        </AdminLayout>
    </>)
}
